import { useState } from 'react';
import { Button } from '@grupoboticario/flora-react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useHistoryWithHost } from 'routes/useHistoryWithHost';
import { HiArrowNarrowRight } from 'react-icons/hi';
import { useWindowSize } from 'hooks';
import { ApplicationState } from 'store/store.inteface';
import { useDispatch, useSelector } from 'react-redux';
import { toggleOpenModalAction } from 'store/modules/claims/actions';
import { MdEast, MdWest } from 'react-icons/md';
import { Container, Title, ReportClaim, SwiperWrapper } from './styles';
import data from './data';
import { Step } from './Step';

export const NotifyClaim = () => {
  const [prevEl, setPrevEl] = useState<HTMLDivElement | null>(null);
  const [nextEl, setNextEl] = useState<HTMLDivElement | null>(null);
  const {
    breakpoints: { isMd },
  } = useWindowSize();
  const draftClaims = useSelector(
    (state: ApplicationState) => state.claims.drafts,
  );
  const dispatch = useDispatch();
  const history = useHistoryWithHost();

  const navigateToOpenClaim = () => {
    if (draftClaims.results.length > 1) {
      dispatch(toggleOpenModalAction(true));
      return;
    }
    history.push('/openclaim');
  };
  return (
    <Container>
      <Title>Como avisar um sinistro?</Title>
      <ReportClaim>
        <SwiperWrapper>
          <div ref={setPrevEl} className="swiper-button-prev">
            <MdWest />
          </div>
          <Swiper
            modules={[Navigation, Pagination]}
            navigation={{
              prevEl,
              nextEl,
            }}
            pagination={{ clickable: true }}
            className="swiper-container"
          >
            {data.map(step => (
              <SwiperSlide key={step.imgAlt}>
                <Step
                  {...step}
                  img={step.img}
                  imgAlt={step.imgAlt}
                  title={step.title}
                  content={step.content}
                />
              </SwiperSlide>
            ))}
          </Swiper>
          <div ref={setNextEl} className="swiper-button-next">
            <MdEast />
          </div>
        </SwiperWrapper>

        <Button
          size={isMd ? 'medium' : 'large'}
          onClick={() => navigateToOpenClaim()}
          has="iconRight"
          icon={<HiArrowNarrowRight size={15} />}
        >
          Avisar Sinistro
        </Button>
      </ReportClaim>
    </Container>
  );
};
